import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 24, once = true, className = "" }) {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function RevealLines({ text, className = "", tag = "span", stagger = 0.12 }) {
  const reduced = useReducedMotion();
  const Tag = motion[tag] || motion.span;
  const words = text.split(" ");
  if (reduced) return <span className={className}>{text}</span>;
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="reveal-mask inline-block align-bottom mr-[0.25em]">
          <Tag
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1,
              delay: 0.15 + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="inline-block"
          >
            {w}
          </Tag>
        </span>
      ))}
    </span>
  );
}
